// extracted by mini-css-extract-plugin
export default {"locationFilter":"filter-dancer-location_locationFilter__0WgL8"};